import React from "react";
import { CircularProgress } from "@mui/material";

const LoadingComp = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "10vh",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CircularProgress color="primary" />
    </div>
  );
};

export default LoadingComp;
